<template>
  <modal
    :id="modalId"
    class="with-subtitle"
    ref="modal"
    title="You are inviting a new user"
    @close="close"
    is-simplified-modal
  >
    <template v-slot:title>
      <h2 class="title">Manage User Ecosystem Member Package</h2>
    </template>

    <template v-slot:body>
      <div class="p-4 min-h-[200px]" v-if="user">
        <div class="tw-flex items-center">
          Select a package for {{ user.name }}:
          <Dropdown
            class="max-w-[200px] ml-2"
            v-model="selectedPackageId"
            :options="packages"
            @update:model-value="updateSelectedPackage"
          />
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="tw-flex justify-end w-full">
        <p v-if="isUpdateSuccessful">
          Package updated successfully!
        </p>
        <DsButton
          style="height: max-content;"
          class="ml-2"
          label="Cancel"
          variant="secondary"
          size="small"
          :disabled="isUpdatingPackage"
          @click="close"
          />
        <DsButton
          style="height: max-content;"
          class="ml-2"
          label="Save"
          variant="primary"
          size="small"
          :disabled="!hasPackageChanged"
          @click="updatePackage"
        />
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Modal from '@/components/Modals/Modal.vue'
  import MODAL_IDS from '@/constants/modal-ids'
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '@/store/modules/ui'
  import { EcosystemMemberPackages } from '@/api/ecosystem-member-packages'
  import Dropdown from '@/components/Dropdown/Dropdown.vue'
  import { updateUserEcosystemRolePackage } from '@/api/user'

  export default defineComponent({
    name: "ManageUserEcosystemMemberPackage",
    components: {
      Dropdown,
      Modal
    },
    data() {
      return {
        modalId: MODAL_IDS.MANAGE_USER_ECOSYSTEM_MEMBER_PACKAGE,
        packages: [],
        selectedPackage: null,
        selectedPackageId: null,
        userPackageId: null,
        isUpdatingPackage: false,
        isUpdateSuccessful: null,
      }
    },
    computed: {
      hasPackageChanged(): bool {
        return this.selectedPackageId !== this.userPackageId
      },
      user() {
        return this.$store.state.ui.modalContext && this.$store.state.ui.modalContext.user
      }
    },
    async mounted() {
      await this.fetchPackages()

      this.userPackageId = this.user?.package_id

      if (this.userPackageId) {
        this.selectedPackageId = Number(this.userPackageId)
      }
    },
    methods: {
      updateSelectedPackage(packageId) {
        this.selectedPackageId = packageId
      },
      updatePackage () {
        this.isUpdatingPackage = true

        updateUserEcosystemRolePackage(this.user.id, this.selectedPackageId)
          .then(() => {
            this.isUpdatingPackage = false
            this.userPackageId = this.selectedPackageId

            this.isUpdateSuccessful = true

            this.$bus.emit('userUpdated')

            this.close()
          })
          .catch(errors => {
            this.isUpdatingPackage = false
            this.isUpdateSuccessful = false
            console.log(errors)
          })
          .finally(() => {
            this.isUpdatingPackage = false
            this.isUpdateSuccessful = false
          })
      },
      async fetchPackages() {
        try {
          const response = await EcosystemMemberPackages.get()

          const packages = response.map(pkg => ({ value: pkg.id, label: pkg.title }))
          packages.unshift({ value: null, label: 'No Package' })

          this.packages = packages
          this.selectedPackageId = this.user?.package_id
        } catch (e) {
          console.log(e)
        }
      },
      close() {
        this.$store.commit(UI_MUTATION_TYPES.HIDE_MODAL, this.modalId)
        this.$store.commit(UI_MUTATION_TYPES.SET_MODAL_CONTEXT, null)
        this.$emit('close')
      },
    }
  })
</script>

<style scoped lang="scss">

</style>
